module.exports = __webpack_public_path__ + "static/media/nick26.7b67c677.jpg";